import { ArtefactKind } from "@/services/backend/artefacts/kind";
import { cn } from "@/shared/lib/utils";
import {
  Binoculars,
  ClipboardList,
  FlaskRound,
  LucideIcon,
  PackageOpen,
  Shapes,
} from "lucide-react";

export const milestoneIcon: { [key: string]: LucideIcon } = {
  [ArtefactKind.Delivery]: PackageOpen,
  [ArtefactKind.Documentation]: FlaskRound,
  [ArtefactKind.Counting]: Binoculars,
  [ArtefactKind.Differentiation]: Shapes,
  [ArtefactKind.Inspection]: ClipboardList,
};

export function MilestoneIcon(props: { icon: LucideIcon }) {
  return (
    <span
      className={cn(
        "bg-secondary flex h-8 w-8 items-center justify-center rounded-full",
      )}
    >
      <props.icon className={cn("h-4 w-4")} />
    </span>
  );
}

export const milestoneStateLabel: { [key: string]: string } = {
  [ArtefactKind.Delivery]: "In Lieferung",
  [ArtefactKind.Documentation]: "Dokumentation",
  [ArtefactKind.Counting]: "Zählung",
  [ArtefactKind.Differentiation]: "Differenzierung",
  [ArtefactKind.Inspection]: "Bericht",
};

export function MilestoneLabel({ status }: { status: string }) {
  return <span className={cn("flex")}>{milestoneStateLabel[status]}</span>;
}
